import { Box } from "../../../theme/containers";
import React from "react";
import { iTimer } from "./types";

/**
 * Utility function for padding 0 to time values
 * @param value
 * @param padding
 * @returns
 */
const paddingLeft = function(value: string | number, padding: string) {
    return String(padding + `${value}`).slice(-padding.length);
};

/**
 * Digital Clock component
 * @param param0
 * @returns
 */
const DigitalClock = ({ timer }: { timer: iTimer }) => {
    const elapsed = timer.elapsed / 1000;
    const hours = Math.floor(elapsed / 3600);
    const minutes = Math.floor((elapsed - hours * 3600) / 60);
    const seconds = Math.floor(elapsed - hours * 3600 - minutes * 60);
    return (
        <Box backgroundColor="monotoneMidDark" p={4} color="brilliant">
            {paddingLeft(hours, "00")}:{paddingLeft(minutes, "00")}:
            {paddingLeft(seconds, "00")}
        </Box>
    );
};

export default DigitalClock;
